import React, {Component} from 'react';
import { Document, Page, pdfjs } from "react-pdf";
import { handleDownloadClick } from "../../utils/Download";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const options = {
	cMapUrl: 'cmaps/',
	cMapPacked: true,
};

export default class PdfRender extends Component{
	constructor(props) {
		super(props);

		this.state = {
			file: this.props.file || './storage/sample.pdf',
			numPages: null,
			pageNumber: 1,
			download: !this.props.download,
			see: !this.props.see
		};
	}

	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages });
	};

	previousPage = () => this.changePage(-1);

	nextPage = () => this.changePage(1);

	changePage = offset => this.setState(prevState => ({
		pageNumber: (prevState.pageNumber || 1) + offset,
	}));

	handleShow() {
		// href, pas pathname : le fichier peut être servi par un autre domaine
		// (l'API) et non par le front.
		window.location.href = this.state.file;
	}

	render() {
		const { file, pageNumber, numPages } = this.state;

		return (
			<>
				<Document
					options={options}
					file={file}
					onLoadSuccess={this.onDocumentLoadSuccess}
					// renderMode="svg"
				>
					<Page pageNumber={pageNumber} />

					<div className="page-controls">
						<button
							disabled={pageNumber <= 1}
							onClick={this.previousPage}
							type="button"
						><i className="fas fa-chevron-left"> </i></button>
						{ this.state.download ? <button
							onClick={(e) => handleDownloadClick(e, this.props.file)}
							type="button"
						><i className="fas fa-download"> </i></button> : '' }
						{ this.state.see ? <button
							onClick={(e) => this.handleShow()}
							type="button"
						><i className="fas fa-eye"> </i></button> : '' }
						<span>
                {`Page ${pageNumber || (numPages ? 1 : '--')} a ${numPages || '--'}`}
            </span>
						<button
							disabled={pageNumber >= numPages}
							onClick={this.nextPage}
							type="button"
						><i className="fas fa-chevron-right"> </i></button>
					</div>

				</Document>
			</>
		);
	}
}